export default "__VITE_ASSET__f54daa67__"